import React, {  useState } from "react";
import { useNavigate } from "react-router-dom";


export default function CDLanding() {
  let navigate = useNavigate();


  const [isLoading, setLoader] = useState(false);

  const signIn = async () => {
    navigate("/signIn?from=delete");
  };

  return (
    <>
      {!isLoading && (
        <div className="bg-primary text-white  px-6 py-8 relative sh-screen">
          {/* <button className="text-white absolute top-5 right-5 z-50" onClick={()=>navigate("/adminAccess")}>Admin</button> */}
          <img
            alt="human"
            src="../../../images/human21.png"
            className="w-72 absolute z-10 top-0 right-0 h-full"
          />
          <div className="z-20 relative  flex flex-col sm:w-3/5 mx-auto h-full">
            <div className="sm:flex sm:justify-center">
              <img
                alt="logo"
                src="../../../images/Logo.svg"
                className="mb-12 sm:mt-20"
              />
            </div>
            <div className="w-3/4 text-3xl sm:hidden">
              Early <br />
              symptom <br />
              assessment <br />
              and triage
            </div>
            <div className="w-3/4 text-3xl hidden sm:block sm:w-full sm:text-center">
              Early symptom assessment <br />
              and triage
            </div>
            <div className="flex flex-col flex-1 justify-center">
              <div className="text-center font-semibold text-2xl">
                Please sign in to complete 
                <br />
                the profile deletion process.
              </div>
              <div className="flex mt-5 mb-4 w-full mx-auto justify-center">
                <button
                  className="max-w-[200px] flex-1 items-center bg-white rounded-2xl mr-2 text-primary font-semibold text-base sm:text-lg p-3 px-4 flex"
                  onClick={signIn}
                >
                  <div className="flex-1">Sign In</div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    className="w-4 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"
                    />
                  </svg>
                </button>

              </div>


            </div>
          </div>
        </div>
      )}
      {isLoading && (
        <div className="bg-white absolute h-screen w-full z-50 flex  flex-col">
          <div className="flex-1"></div>
          <div>
            {" "}
            <img src="Loading_prog.gif" alt="loader" className="h-24 mx-auto" />
          </div>
          <div className="flex-1"></div>
        </div>
      )}
    </>
  );
}
